import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CustomChatNames } from '@/constants/CustomChats'
import { GroupCategories } from '@/store/chats/IChats'
import { GroupCategoriesMap } from '@/store/chats/constants'

export interface AlogixChat {
  id: typeof CustomChatNames.ALOGIX
  type: 'chat'
  name: string
  nick: string
  groups: GroupCategories[],
  balance: string
  notifyMuted?: boolean
  fullLoaded: boolean
}

interface AlogixState {
  chat: AlogixChat
}

const initialState: AlogixState = {
  chat: {
    id: CustomChatNames.ALOGIX,
    type: 'chat',
    name: 'alogix_ai_assistant',
    nick: '',
    groups: [GroupCategoriesMap.favorite],
    balance: '0',
    notifyMuted: false,
    fullLoaded: false
  }
}

const alogixChat = createSlice({
  name: 'alogixChat',
  initialState,
  reducers: {
    setBalance(state, { payload }: PayloadAction<string>) {
      state.chat.balance = payload
    },
    setNick(state, { payload }: PayloadAction<string>) {
      state.chat.nick = payload
    },
    setGroups(state, { payload }: PayloadAction<GroupCategories[]>) {
      state.chat.groups = Array.from(new Set(payload))
    },
    addGroups(state, { payload }: PayloadAction<GroupCategories | GroupCategories[]>) {
      const newGroups = Array.isArray(payload) ? payload : [payload]
      const groups = [
        ...state.chat.groups,
        ...newGroups
      ]
      state.chat.groups = Array.from(new Set(groups))
    },
    removeGroups(state, { payload }: PayloadAction<GroupCategories | GroupCategories[]>) {
      const removedGroups = Array.isArray(payload) ? payload : [payload]
      const groupsSet = new Set(state.chat.groups)
      removedGroups.forEach(group => {
        groupsSet.delete(group)
      })
      state.chat.groups = Array.from(new Set(groupsSet))
    },
    setNotifyMuted(state, { payload }: PayloadAction<boolean>) {
      state.chat.notifyMuted = payload
    },
  }
})

export const {
  setBalance,
  setNick,
  setGroups,
  addGroups,
  removeGroups,
  setNotifyMuted,
} = alogixChat.actions
export default alogixChat.reducer


